import { DataGrid } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import Checkbox from "@mui/material/Checkbox";
import { useTheme, alpha } from "@mui/material/styles";

const PurchaseOrderGrid = ({ rows = [], selectedId, onSelect }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const handleSelect = (id) => {
    if (String(selectedId) === String(id)) {
      onSelect(null);
      return;
    }

    onSelect(id);
  };

  const columns = [
    {
      field: "checked",
      headerName: "",
      width: 50,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Checkbox
          size="small"
          checked={String(selectedId) === String(params.id)}
          onClick={(e) => e.stopPropagation()}
          onChange={() => handleSelect(params.id)}
        />
      ),
    },
    { field: "poNumber", headerName: t("assing.purchaseOrder"), width: 140 },
    { field: "poItem", headerName: t("assing.poItem"), width: 140 },
    { field: "category", headerName: t("assing.itemCtg"), width: 110 },
    { field: "erpMaterial", headerName: t("assing.materialErp"), width: 170 },
    { field: "shortText", headerName: t("assing.descMaterialErp"), width: 260 },
    { field: "qty", headerName: t("assing.qty"), width: 160 },
    { field: "uom", headerName: t("assing.unit"), width: 180 },
    { field: "iva", headerName: t("simulate.iva"), width: 180 },    
    { field: "ncm", headerName: t("simulate.ncm"), width: 150 },  
  ];

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        density="compact"
        hideFooter
        disableRowSelectionOnClick
        onRowClick={(params) => handleSelect(params.id)}
        getRowClassName={(params) =>
          String(params.id) === String(selectedId) ? "grid-row-selected" : ""
        }
        sx={{
          border: 0,
          width: "100%",
          minWidth: 0,
          "& .MuiDataGrid-main": {
            overflow: "auto",
          },
          "& .MuiDataGrid-columnHeaders": {
            minWidth: "max-content",
            backgroundColor: "background.subtle",
            borderBottom: "2px solid",
            borderColor: "divider",
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
            overflowY: "auto",
          },
          "& .MuiDataGrid-row": {
            minWidth: "max-content",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
            fontSize: "0.7rem",
            color: "text.secondary",
            textTransform: "uppercase",
          },
          "& .grid-row-selected": {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
        }}
      />
    </div>
  );
};

export default PurchaseOrderGrid;